<template>
  <section :class="isMobile ? 'repair-step mobile-repair-step' : 'repair-step'">
    <div class="title">维修方案说明（工艺）</div>

    <div class="form">
      <div class="form-item">
        <div class="step-label">故障隐患零配件清单</div>

        <upload-annex-vue
          ref="uploadAnnex"
          :attachment="problemForm.annex"
          :disabled="!isEdit"
        ></upload-annex-vue>
      </div>

      <root-cause-analyses-vue
        :rootCauseAnalyses="problemForm.maintenancePlan"
        ref="mp"
        :formdata="problemForm"
        title="维修方案"
        :disabled="!isEdit"
        type="2"
      >
      </root-cause-analyses-vue>
      <div class="form-item">
        <a-space
          :size="isMobile ? 20 : 10"
          :direction="isMobile ? 'vertical' : 'horizontal'"
        >
          <div class="df">
            <div class="step-label">完成时间</div>
            <div class="data">
              <select-day-vue
                :defaultVal="problemForm.completeDate"
                @userDelectDay="userDelectDay"
                :disabled="!isEdit"
              ></select-day-vue>
            </div>
          </div>
          <div class="df">
            <div class="step-label">经手人</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.principal"
                placeholder="请输入经手人"
                :disabled="!isEdit"
                allow-clear
              ></a-input>
            </div>
          </div>
          <div class="df" v-if="problemForm.rollbackReason">
            <div class="step-label">回退原因</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.rollbackReason"
                :disabled="true"
              ></a-input>
            </div>
          </div>
          <div class="df" v-if="problemForm.username">
            <div class="step-label">编辑人</div>
            <div class="data">
              {{ problemForm.username }}
            </div>
          </div>
        </a-space>
      </div>
    </div>

    <div class="footer df both-side">
      <a-button type="primary" @click="saveInfo" :disabled="!isEdit"
        >保存</a-button
      >
      <a-space :size="isMobile ? 10 : 50">
        <a-button @click="nextStep" :disabled="!isEdit">下一步</a-button>
        <a-button @click="backPreStep" type="danger" :disabled="!isEdit"
          >退回上一级</a-button
        >
      </a-space>
    </div>
  </section>

  <roll-back-modal-vue
    ref="rollBackModal"
    @rollBack="rollBack"
  ></roll-back-modal-vue>
</template>

<script>
import { defineComponent, reactive, watch, ref, computed } from "vue";
import { useStore } from "vuex";
import {
  updateMaintenancePlan,
  maintenancePlanConfirm,
  maintenancePlanRollback,
  saveOrUpdateRepairEquipment,
} from "@/request/view/repair";
import { useRoute, useRouter } from "vue-router";
import { Toast, showUploading, hideUploading } from "@/utils/index";
import { showModal } from "../serve/modal";
import uploadImgVue from "./uploadImg.vue";
import uploadVideoVue from "./uploadVideo.vue";
import selectDayVue from "./selectDay.vue";
import rollBackModalVue from "./rollBackModal.vue";
import uploadAnnexVue from "./uploadAnnex.vue";
import rootCauseAnalysesVue from "./contentDsc.vue";

export default defineComponent({
  components: {
    uploadImgVue,
    uploadVideoVue,
    selectDayVue,
    rollBackModalVue,
    uploadAnnexVue,
    rootCauseAnalysesVue,
  },
  props: {
    machine: Object,
    progress: Object,
    meta: Object,
  },
  setup(props, context) {
    const router = useRouter();
    const back = () => {
      // router.replace("/repairequipment");
      context.emit("back");
    };
    const store = useStore();
    const isMobile = computed(() => store.state.isMonile);

    const problemForm = reactive({
      annex: null,
      completeDate: null,
      id: null,
      isEditable: true,
      maintenancePlan: null,
      principal: null,
      repairEquipmentId: null,
      rollbackReason: null,
      type: null,
      userId: null,
      username: null,
    });
    const getEditLock = () => {
      const { id, username } = store.state.user.user;
      if (problemForm.userId === null && problemForm.username === null) {
        return true;
      } else if (problemForm.userId == id) {
        return true;
      }
      return false;
    };
    const isEdit = computed(() => {
      if (store.getters.user) {
        const unlock = getEditLock();
        return (
          props.meta["/technologyupdateInfo"] &&
          machineInfo.repairProcess == 2 &&
          unlock
        );
      }
      return false;
    });
    const uploadImg = ref();
    const uploadVideo = ref();
    const rollBackModal = ref();
    const uploadAnnex = ref();
    const mp = ref();
    const machineInfo = reactive({
      id: null,
      repairProcess: null,
    });
    const saveInfo = async () => {
      showUploading("上传中");
      // //上传附件
      let annexFileUrl = null;
      await uploadAnnex.value
        .uploadFile()
        .then((res) => {
          annexFileUrl = JSON.stringify(res);
        })
        .catch((err) => {
          console.log(err);
          hideUploading();
        });

      // //维修方案
      await mp.value
        .uploadContent()
        .then((res) => {
          fpii = res;
        })
        .catch((err) => {
          console.log(err);
          hideUploading();
        });

      updateMaintenancePlan({
        annex: annexFileUrl,
        completeDate: problemForm.completeDate,
        id: problemForm.id,
        isEditable: problemForm.isEditable,
        principal: problemForm.principal,
        processRecords: problemForm.processRecords,
        repairEquipmentId: machineInfo.id,
        rollbackReason: problemForm.rollbackReason,
        userId: store.state.user.user.id,
        username: store.state.user.user.username,
        type: 2,
      })
        .then((res) => {
          context.emit("resetProcess");
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          problemForm.id = res.data.id;
          hideUploading();
        })
        .catch((err) => {
          console.log(err);
          hideUploading();
        });
    };

    const nextStep = () => {
      showModal({
        title: "提示",
        toastText: "请先保存信息再确认到下一步流程？",
        success: () => {
          maintenancePlanConfirm({
            maintenancePlanId: problemForm.id,
          })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200 && res.message === "成功") {
                context.emit("updateMachineInfo");
                context.emit("updateProcess", res.data);
                back();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const rollBack = (e) => {
      maintenancePlanRollback({
        maintenancePlanId: problemForm.id,
        rollbackReason: e,
      })
        .then((res) => {
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          if (res.code === 200) {
            rollBackModal.value.handleCancel();
            context.emit("updateMachineInfo");
            // context.emit("updateProcess", res.data);
            back();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const backPreStep = () => {
      rollBackModal.value.showModal();
      rollBackModal.value.setInputData(problemForm.rollbackReason);
    };

    const userDelectDay = (day) => {
      problemForm.completeDate = day;
    };
    // 赋值
    const setProblemData = (data) => {
      problemForm.annex = data.annex;
      problemForm.completeDate = data.completeDate;
      problemForm.id = data.id;
      problemForm.maintenancePlan = data.maintenancePlan;
      problemForm.principal = data.principal;
      problemForm.repairEquipmentId = data.repairEquipmentId;
      problemForm.rollbackReason = data.rollbackReason;
      problemForm.type = data.type;
      problemForm.userId = data.userId;
      problemForm.username = data.username;
    };
    // 赋值
    const setmachinInfo = (data) => {
      machineInfo.id = data.id;
      machineInfo.repairProcess = data.repairProcess;
    };

    watch(
      () => props.progress,
      (val) => {
        setProblemData(val);
        console.log(val, '过程数据是');
      },
      {
        immediate: true,
        deep: true,
      }
    );
    watch(
      () => props.machine,
      (val) => {
        setmachinInfo(val);
        console.log(val, '设备数据');
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      problemForm,
      machineInfo,
      saveInfo,
      nextStep,
      backPreStep,
      userDelectDay,
      uploadImg,
      uploadVideo,
      rollBack,
      isEdit,
      rollBackModal,
      uploadAnnex,
      isMobile,
      mp,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
